module.exports = __webpack_public_path__ + "static/media/IMG_3764 EDITED.7eb40ab1.JPG";